module.exports = __webpack_public_path__ + "static/media/Group-Check.0168033b.svg";